export default "__VITE_ASSET__DUXdfBB6__"